// src/utils/idGenerator.ts
/**
 * 生成唯一ID
 * @returns 唯一ID字符串
 */
export const generateUniqueId = (): string => {
    const timestamp = Date.now().toString(36);
    const random = Math.random().toString(36).substr(2, 9);
    const performance = window.performance.now().toString(36);
    return `${timestamp}-${random}-${performance}`;
};

/**
 * 生成短ID（用于显示）
 */
export const generateShortId = (): string => {
    return Math.random().toString(36).substr(2, 6);
};

/**
 * 生成消息ID
 */
export const generateMessageId = (): string => {
    return `msg_${generateUniqueId()}`;
};

/**
 * 生成会话ID
 */
export const generateSessionId = (): string => {
    return `session_${generateUniqueId()}`;
};
